import { render, staticRenderFns } from "./AddForwarder.vue?vue&type=template&id=79bd7e73&"
import script from "./AddForwarder.vue?vue&type=script&lang=js&"
export * from "./AddForwarder.vue?vue&type=script&lang=js&"
import style0 from "./AddForwarder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79bd7e73')) {
      api.createRecord('79bd7e73', component.options)
    } else {
      api.reload('79bd7e73', component.options)
    }
    module.hot.accept("./AddForwarder.vue?vue&type=template&id=79bd7e73&", function () {
      api.rerender('79bd7e73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Forwarders/Modals/AddForwarder.vue"
export default component.exports